<template>
  <div class="view pa24">
    <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
      :close-on-click-modal="false" :before-close="closeDialog">
      <el-form ref="dealerRuleForm" :model="ruleForm" :rules="rules" label-width="120px">
        <!-- 加一个零件的选择 -->
        <el-form-item label="计划单" prop="classIds">
          <el-select v-model="ruleForm.excleId" placeholder="请选择计划单" @change="changeExcle">
            <el-option v-for="item in ruleForm.classList" :key="item.id" :label="item.serial"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司" prop="company">
          <el-select v-model="ruleForm.companyName" placeholder="请选择公司">
            <el-option label="浙江利佳航空设备制造股份有限公司" value="浙江利佳航空设备制造股份有限公司"></el-option>
            <el-option label="利佳（上海）航空设备有限公司" value="利佳（上海）航空设备有限公司"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货单位" prop="consignee">
          <el-input v-model="ruleForm.consignee" placeholder="请输入收货单位"></el-input>
        </el-form-item>
        <el-form-item label="收货地址" prop="address">
          <el-input v-model="ruleForm.address" placeholder="请输入收货地址"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contact">
          <el-input v-model="ruleForm.contact" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="送货单号" prop="code">
          <el-input v-model="ruleForm.code" placeholder="请输入送货单号"></el-input>
        </el-form-item>
        <el-form-item label="合同编号" prop="contractCode">
          <el-input v-model="ruleForm.contractCode" placeholder="请输入合同编号"></el-input>
        </el-form-item>
        <el-form-item label="送货日期" prop="time">
          <el-date-picker v-model="ruleForm.time" type="date" placeholder="选择计划送货日期" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>

        <el-form-item label="公司地址" prop="companyAddress">
          <el-input v-model="ruleForm.companyAddress" placeholder="请输入公司地址"></el-input>
        </el-form-item>
        <el-form-item label="电话传真" prop="telephone">
          <el-input v-model="ruleForm.telephone" placeholder="请输入电话传真"></el-input>
        </el-form-item>
        <el-form-item label="送货人" prop="delivery">
          <el-input v-model="ruleForm.delivery" placeholder="请输入送货人"></el-input>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item label="备注" prop="remark">
          <el-input v-model="ruleForm.remark" type="textarea" placeholder="请输入备注"></el-input>
        </el-form-item>
        <div v-for="(item, index) in ruleForm.productList" :key="index">
          <el-form-item :label="`公司生产计划号`" :prop="'planCode.' + index" :rules="rules.planCode">
            <el-input v-model="ruleForm.planCode[index]" placeholder="请输入公司生产计划号"></el-input>
            <label style="color: red;">产品：{{item.name}}</label>
          </el-form-item>
          <el-form-item :label="`设备序号/备注`" :prop="'partNumber.' + index" :rules="rules.partNumber">
            <el-input v-model="ruleForm.partNumber[index]" placeholder="请输入设备序号/备注"></el-input>
            <label style="color: red;">产品：{{item.name}}</label>
          </el-form-item>
        </div>

        <div class="dialog-footer" style="text-align: right">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button class="btncss" @click="confirmAddCustomer">生 成</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { getDelivery, queryList } from "@/api/boomClass.js";
  import { baseUrl } from "@/utils/index";

  export default {
    name: "addPageClass",
    components: {},
    props: [],
    data() {
      let token = localStorage.getItem("token");
      return {
        fileList: [],
        uploadUrl: this.$store.state.uploadingUrl,
        ossUrl: this.$store.state.ossUrl,
        upParams: {
          token: token,
        },
        provinces: [],
        classType: null,
        dialogVisible: false,
        title: "",
        ruleForm: {
          excleId: "",
          companyName: "",
          consignee: "",
          address: "",
          contact: "",
          phone: "",
          code: "",
          contractCode: "",
          time: "",
          companyAddress: "",
          telephone: "",
          delivery: "",
          remark: "",
          classIds: [],
          classList: [],
          planCode: [], // 初始化为空数组
          partNumber: [], // 初始化为空数组
          productList: []
        },
        rules: {},
      };
    },
    onShow() { },
    methods: {
      async openDialog(dat) {
        // this.ruleForm={}
        this.dialogVisible = true;
        this.title = "生成出库清单";
        this.resetForm();
      },
      resetForm() {
        let param = {
          excelType: 0,
        };
        queryList(param).then((res) => {
          this.ruleForm.classList = res.data.list;
          console.log(this.ruleForm.classList);
        });
      },
      changeExcle(data) {
        let param = {
          excelType: 0,
          excelId: data,
        };
        queryList(param).then((res) => {
          this.ruleForm.productList = res.data.list[0].excleDetails;

          // 获取选中的计划单数据
          const selectedClass = this.ruleForm.classList.find(item => item.id === data);
          if (selectedClass && selectedClass.excleDetails && selectedClass.excleDetails.length > 0) {
            const firstExcleDetail = selectedClass.excleDetails[0];
            // 只有当这些字段为空时才进行赋值，避免覆盖用户输入
            if (!this.ruleForm.consignee) this.ruleForm.consignee = firstExcleDetail.orderCompany; // 设置收货单位
            if (!this.ruleForm.contractCode) this.ruleForm.contractCode = firstExcleDetail.contract; // 设置合同编号
            if (!this.ruleForm.companyAddress) this.ruleForm.companyAddress = '上海市静安区江杨南路296号'; // 公司地址
            if (!this.ruleForm.telephone) this.ruleForm.telephone = '021-66528751/56836845'; // 电话传真
          }
        });
      },
      closeDialog() {
        this.dialogVisible = false;
      },
      confirmAddCustomer() {
        console.log(this.ruleForm);
        this.$refs.dealerRuleForm.validate((valid) => {
          if (valid) {
            getDelivery(this.ruleForm).then((res) => {
              if (res.code === 200) {
                console.log(baseUrl);
                let urls = baseUrl + res.data;
                const link = document.createElement("a");
                link.href = urls;
                link.style.display = "none";
                link.download = "利佳航空出库单.xlsx"; // 设置下载的文件名
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.$message({
                  type: "success",
                  message: "导出成功",
                });
              }
            });
            this.$emit("getList");
            this.closeDialog();
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .component {
    margin-bottom: 10px;

    &.even {
      background-color: #f5f5f5;
    }

    &.odd {
      background-color: #fff;
    }
  }

  .accessory {
    margin-bottom: 10px;
    padding-left: 20px;

    &.even {
      background-color: #f5f5f5;
    }

    &.odd {
      background-color: #fff;
    }
  }

  .sub-accessory {
    margin-bottom: 10px;
    padding-left: 40px;

    &.even {
      background-color: #f5f5f5;
    }

    &.odd {
      background-color: #fff;
    }
  }
</style>